import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo'
import { Col, Form, Row } from 'react-bootstrap';
import ShowVideo from '../shared/ShowVideo';


export default function SchoolClass(props) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);


  const [currentItem, setCurrentItem] = useState(null);
  const [items, setItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);
  const LoadingRows = Array.from({ length: 5 });

  const [degree, setDegree] = useState(0);
  const [field, setField] = useState("");
  const [name, setName] = useState("");


  useEffect(() => {
    setLoading(true);


    var params = { login: util.getTrustedUser(), lastIndex: 0, pageSize: 0 };
    var url = config.Server + `/school/school-class/list`;
    console.log("params is>", params);
    console.log("url is>", url);
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          console.log("response is>", response);

          setItems(response);
          setFilterItems(response);

          setLoading(false);

        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });

  }, []);

  const addNewItem = function () {
    setCurrentItem(null);
    setDegree(0);
    setName("");
    setField("");
    setEditFormVisible(true);
  }
  const onRowEditClick = function (row) {
    setCurrentItem(row);
    setDegree(row.degree);
    setName(row.name);
    setField(row.field);
    setEditFormVisible(true);
  }
  const onRowDeleteClick = function (row) {
    setCurrentItem(row);
    setConfirmDeleteVisible(true);
  }

  const closeEditDialog = function () {
    setEditFormVisible(false);
  }
  const deleteItem = function () {
    setDeleting(true);
    var id = currentItem.id;
    var params = { login: util.getTrustedUser(), id: id };
    var url = config.Server + `/school/school-class/delete`;
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          var tmp = [...items];
          for (var i = 0; i < tmp.length; i++) {
            if (tmp[i].id === id) {
              tmp.splice(i, 1);
              break;
            }
          }
          setCurrentItem(null);
          setItems(tmp);
          setFilterItems(tmp);

          setDeleting(false);
          setConfirmDeleteVisible(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setDeleting(false);
        }
      })
      .catch(error => {
        setDeleting(false);
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
      });
  }
  const onDeleteConfirm_Accept = function () {
    deleteItem();
  }
  const onDeleteConfirm_Reject = function () {
    if (deleting) return;
    setConfirmDeleteVisible(false);
  }

  const checkDataEntry = function () {
    if ((degree == "") || (degree == null)) {
      setErrorMessage("پایه تحصیلی را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if (name.trim().length == 0) {
      setErrorMessage("نام کلاس را وارد کنید");
      setErorVisible(true);
      return false;
    }
    if (field == null || field.id == "" || !field.id) {
      setErrorMessage("رشته را انتخاب کنید");
      setErorVisible(true);
      return false;
    }
    return true;
  }
  const saveItem = function () {
    if (!checkDataEntry()) return;

    setSaving(true);
    var id = "";
    if (currentItem != null) {
      id = currentItem.id;
    }
    var params = { login: util.getTrustedUser(), id: id, degree: degree, name: name, fieldId: field.id };
    var url = config.Server + `/school/school-class/save`;
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          var tmp = [...items];
          if (id === "") {
            tmp.push(response);
          }
          else {
            console.log("fff>", field);
            for (var i = 0; i < tmp.length; i++) {
              if (tmp[i].id === id) {
                tmp[i] = {
                  id: id,
                  name: name,
                  degree: degree,
                  field: { id: field.id, title: field.title },
                }
                setCurrentItem(tmp[i]);
                break;
              }
            }
          }
          setItems(tmp);
          setFilterItems(tmp);

          setSaving(false);
          setEditFormVisible(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });

  }
  const editDialogFooter = function () {
    return (
      <GeneralDialogFooter onOkClick={() => { saveItem() }} onCancelClick={() => { closeEditDialog() }} saving={saving} />
    )
  }
  const onInputChange = function (e, n) {
    var val = '';
    val = (e.target && e.target.value) || '';
    if (n === "degree") setDegree(val);
    else if (n === "name") setName(val);
  }

  const onComboChange = function (name, value) {
    if (name === "field") {
      setField(value);
    }
    console.log("field-->", field);
    return
  }

  const setRowActions = function (row) {
    return (
      <Row className="justify-content-md-center" style={{}}>
        <Button icon="pi pi-pencil" rounded severity="success" style={{ width: "45px", margin: "0px 3px", float: "right" }} onClick={() => onRowEditClick(row)} title="ویرایش" />
        <Button icon="pi pi-trash" rounded severity="danger" style={{ width: "45px", margin: "0px 3px", float: "right" }} onClick={() => onRowDeleteClick(row)} title="حذف" />
      </Row>
    );
  }

  return (
    <>
      <ShowVideo videoId="school_create_classes" top={65} md={6} />
      <div className="card">
        {
          loading ?
            <DataTable value={LoadingRows} className="p-datatable-striped">
              <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
              <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
            </DataTable>
            :
            <>
              <div className="page-caption">لیست کلاس ها</div>
              <Row style={{}}>
                <Col md={2}>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign: "right", margin: "10px" }}>
                    <Button label="افزودن به لیست" icon="pi pi-plus" onClick={() => addNewItem()} severity="secondary" iconPos="right" />
                  </div>
                </Col>
              </Row>

              <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{}} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id" selection={currentItem} onSelectionChange={(e) => { setCurrentItem(e.value) }}>
                {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column> */}
                <Column header="#" headerStyle={{ width: '20px' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="name" header={"نام کلاس"} sortable className="list-cell-text-align"></Column>
                <Column field="degree" header={"پایه"} sortable className="list-cell-text-align"></Column>
                <Column field="field.title" body={(row) => row.field.title} header={"رشته"} sortable className="list-cell-text-align"></Column>
                <Column body={(row) => setRowActions(row)} exportable={false} style={{ width: "100px" }}></Column>
              </DataTable>
            </>
        }
      </div>
      {
        editFormVisible ?
          <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            header="ثبت کلاس" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => closeEditDialog()}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td colSpan={2}>
                    <FieldCombo returnFullItem={true} value={field} onChange={(val) => onComboChange('field', val)} />
                  </td>
                </tr>
                <tr><td colSpan={2}>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <FloatLabel>
                      <InputText value={degree} onChange={(e) => { onInputChange(e, "degree") }} id="degree" keyfilter="int" maxLength={2} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                      <label htmlFor="username">پایه تحصیلی</label>
                    </FloatLabel>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <FloatLabel>
                      <InputText value={name} onChange={(e) => { onInputChange(e, "name") }} id="name" keyfilter="" maxLength={100} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                      <label htmlFor="username">نام کلاس</label>
                    </FloatLabel>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
              </tbody>
            </table>

          </Dialog>
          :
          <></>
      }
      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
      <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
    </>
  );
}
